import axios from "axios";
import AxiosClient from "../../services/axios.services";

class DepartamentUserServices {
  getDepartamentsUser = params =>
    AxiosClient.get("/api/app/head_clima_departamento/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getDepartamentUser = id =>
    AxiosClient.get(`/api/app/head_clima_departamento/?tipo_busqueda=pais_id&filter=${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  saveDepartamentUser = data =>
    AxiosClient.post("/api/app/head_clima_departamento/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editDepartamentUser = (id, data) =>
    AxiosClient.put(
      `/api/app/head_clima_departamento/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteDepartamentUser = id =>
    AxiosClient.delete(`/api/app/head_clima_departamento/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new DepartamentUserServices();